// Karta pojedynczej podstrony w gridzie

import React, { FC, useState } from 'react';
import { Trans } from 'react-i18next';
import { FileEarmarkText, Link45deg, PencilFill, Trash } from 'react-bootstrap-icons';

import { axios } from 'api';
import { Button } from 'components/controls';

import styles from 'theme/pages/PanelPages/PanelPages.module.scss';

interface IPageItem {
  id: number;
  symbol: string;
  title: string;
  is_active: boolean;
}

interface IProps {
  item: IPageItem;
  urlValue: string | null;
  onEdit: (id: number) => void;
  onDeleted: () => void;
}

const PageCard: FC<IProps> = ({ item, urlValue, onEdit, onDeleted }) => {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await axios.delete(`/cms/article/${item.id}`);
      onDeleted();
    } finally {
      setIsDeleting(false);
      setConfirmDelete(false);
    }
  };

  return (
    <div className={styles.card} onClick={() => !confirmDelete && onEdit(item.id)}>
      <div className={styles.cardTop}>
        <FileEarmarkText />
        <span className={`${styles.cardBadge} ${item.is_active ? styles.active : styles.inactive}`}>
          {item.is_active ? <Trans>Aktywna</Trans> : <Trans>Nieaktywna</Trans>}
        </span>
      </div>

      <div className={styles.cardBody}>
        <p className={styles.cardTitle}>{item.title || item.symbol}</p>
        {urlValue && (
          <div className={styles.cardUrl}>
            <Link45deg className={styles.cardUrlIcon} />
            <span>/{urlValue}</span>
          </div>
        )}
        <span className={styles.cardSymbol}>{item.symbol}</span>
      </div>

      <div className={styles.cardFooter} onClick={(e) => e.stopPropagation()}>
        <button className={styles.cardEditBtn} onClick={() => onEdit(item.id)}>
          <PencilFill size={11} />
          <Trans>Edytuj</Trans>
        </button>
        <div className={styles.cardSpacer} />
        {confirmDelete ? (
          <div className={styles.deleteConfirm}>
            <Trans>Usunąć?</Trans>
            <Button color="danger" loading={isDeleting} onClick={handleDelete}>
              <Trans>Tak</Trans>
            </Button>
            <Button color="gray" onClick={() => setConfirmDelete(false)}>
              <Trans>Nie</Trans>
            </Button>
          </div>
        ) : (
          <button className={styles.cardDeleteBtn} onClick={() => setConfirmDelete(true)}>
            <Trash size={13} />
          </button>
        )}
      </div>
    </div>
  );
};

export default PageCard;
